// Webpack Imports
//import 'bootstrap';
//BOOTSTRAP PLUGINS
// import 'bootstrap/js/dist/util';
// import 'bootstrap/js/dist/carousel';
// import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/modal';

import 'bootstrap';


// import { is_single } from './src/wordpress-functions';
import { App } from './src/app';
import './src/sticky-header';

console.log(
  `%c
Theme: The Benefit Lab
Author: WebAdictos
Url: https://webadictos.com`,
  'color: green;padding-bottom:.5rem;'
);

window.addEventListener('DOMContentLoaded', function (event) {

  App.init();

});

